import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import MainLayout from '../../../Layout'
import useAppRoutes from '../../../routes/useAppRoutes'

import ProtectedRoute from '../../../routes/ProtectedRoute'

export const NotFound = () => {
  return <h1>Not Found!</h1>
}

const RenderRoutes = ({ routes, ...props }) => {
  const wrapperLayout = (child, key) => {
    if (key === 'login') {
      return child
    }
    return <MainLayout>{child}</MainLayout>
  }

  const appRoutes = useAppRoutes()

  return (
    <BrowserRouter>
      <Routes>
        {appRoutes &&
          Object.keys(appRoutes).map((key) => {
            const route = appRoutes[key]
            return (
              <Route
                key={route.key}
                path={route.path}
                exact={route.exact}
                element={wrapperLayout(
                  <ProtectedRoute
                    permissions={route.permissions}
                    roles={route.roles}
                    requireAuth={route.isSecured}
                  >
                    <route.Component {...props} />
                  </ProtectedRoute>,
                  route.key
                )}
              />
            )
          })}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

RenderRoutes.propTypes = {
  routes: PropTypes.array,
}

export default RenderRoutes
